import React, { FC, HTMLAttributes } from 'react';

import { ReactComponent as EnovaLogoLight } from '../../assets/logo_light.svg';

export type LogoProps = HTMLAttributes<SVGElement>;

export const Logo: FC<LogoProps> = (props) => <EnovaLogoLight {...props} />;

Logo.displayName = 'Logo';
